import { createFileRoute } from '@tanstack/react-router'
import { CampaignsPage } from '../../../components/campaigns/CampaignsPage'

/** Data collection campaigns (spec 2026-10-20-12). */
export const Route = createFileRoute('/$org/campaigns/')({
  component: CampaignsPage,
})
